<se-fe-side-panel [ngClass]="sidePanelClass"
  #sidePanel
  [seFeDataLoaded]="!!profile"
  [(seFeDataVisible)]="showSidePanel"
  (seFeClose)="close()">
  @if (menuOptions) {
    <div seFeSidePanelActions>
      <se-fe-icon-button [seFeMenuTrigger]="moreMenu">
        <se-fe-icon
          seFeDataName="more"
          seFeDataSize="700"
          seFeDataAriaLabel="more">
        </se-fe-icon>
      </se-fe-icon-button>
      <se-fe-menu #moreMenu [seFeDataOptions]="menuOptions" [seFeDataMaxHeight]="'60vh'"></se-fe-menu>
    </div>
  }
  @if (profile) {
    <se-fe-header seFeSidePanelHeader
      [seFeDataTitle]="!headerLink && persona?.full_name"
      [seFeDataSubtitle]="profileSubtitle">
      @if (editableAvatar) {
        <se-fe-avatar
          seFeHeaderVisual
          seFeDataType="persona"
          [seFeDataIdentity]="persona?.full_name"
          [seFeDataImgUrl]="profileImageUrl"
          (seFeClick)="onAvatarClick()">
        </se-fe-avatar>
      }
      @if (!editableAvatar) {
        <se-fe-avatar
          seFeHeaderVisual
          seFeDataType="persona"
          [seFeDataIdentity]="persona?.full_name"
          [seFeDataImgUrl]="profileImageUrl">
        </se-fe-avatar>
      }
      @if (headerLink) {
        <a seFeHeaderTitle seFeLink="low" [href]="headerLink">{{ persona?.full_name }}</a>
      }
    </se-fe-header>
  }
  <div seFeSidePanelContent>
    <ng-content select="[profileSidePanelContent]"></ng-content>
  </div>
</se-fe-side-panel>
